export default __webpack_public_path__ + "static/ryan-2f4da5be1290f863dc0f75a35baa41a9.png";